<ng-container>
    <div fxLayout="row wrap" class="custom-system-footer">
        <div
            fxFlex.sm="100%"
            fxFlex.xs="100%"
            class="footer-block-right"
            ngClass.sm="footer-block-center"
            ngClass.xs="footer-block-center"
        >
            <div class="login-footer-right-block">
                {{ appService.language_dictionary.system_footer_copyright }}
                <a
                    href="http://ifrigate.ru"
                    target="_blank"
                    style="color: #337ab7"
                    [innerHTML]="
                        appService.language_dictionary.system_footer_company
                    "
                ></a>
            </div>
        </div>
    </div>
</ng-container>
